import { QuickSetupWizard } from "../wizard/QuickSetupWizard";

type QuickSetupPageProps = {
  locale: string;
  storeSlug: string;
};

export function QuickSetupPage({ locale, storeSlug }: QuickSetupPageProps) {
  return <QuickSetupWizard locale={locale} storeSlug={storeSlug} />;
}
